import { Link } from '@tanstack/react-router';

export function NotFoundPage() {
  return (
    <main className="mx-auto grid min-h-screen max-w-xl place-items-center px-6 text-center">
      <section>
        <p className="text-6xl font-semibold tracking-tight text-primary">404</p>
        <h1 className="mt-4 text-3xl font-semibold tracking-tight">This stop is not on the map.</h1>
        <p className="mt-3 text-muted-foreground">Return to current bus times and choose a supported stop.</p>
        <Link to="/" className="mt-7 inline-flex rounded-lg bg-primary px-4 py-2 text-primary-foreground">
          Bus times
        </Link>
      </section>
    </main>
  );
}
